import React from 'react';
import ProductCard from './ProductCard';
import './Products.css';

import tshirtImg from '../assets/images/T Shirt Black Girl Mockup.png';
import hoodieImg from '../assets/images/Hoodie Mockup.png';
import stickerImg from '../assets/images/Logo Sticker Blue BG.png';

const productsData = [
  {
    id: 1,
    name: 'T-Shirt',
    description: 'Youth & Adult Sizes',
    availability: 'Only available in white',
    price: 29.95,
    shipping: 4.95,
    images: [
      tshirtImg
    ],
    sizes: ['Youth S', 'Youth M', 'Youth L', 'Adult S', 'Adult M', 'Adult L', 'Adult XL', 'Adult XXL']
  },
  {
    id: 2,
    name: 'Hooded Sweatshirt',
    description: 'Youth & Adult Sizes',
    availability: 'Only available in white',
    price: 49.95,
    shipping: 8.95,
    images: [
      hoodieImg
    ],
    sizes: ['Youth S', 'Youth M', 'Youth L', 'Adult S', 'Adult M', 'Adult L', 'Adult XL', 'Adult XXL']
  },
  {
    id: 3,
    name: 'Adhesive Stickers',
    description: '2" x 2" - $6.95 / 4" x 4" - $9.95',
    availability: '',
    price: 6.95,
    shipping: 3.95,
    images: [
      stickerImg
    ],
    sizes: ['2" x 2"', '4" x 4"'],
    priceOptions: {
      '2" x 2"': 6.95,
      '4" x 4"': 9.95
    }
  }
];

function Products({ addToCart }) {
  return (
    <div className="products-container">
      <div className="products-grid">
        {productsData.map(product => (
          <ProductCard
            key={product.id}
            product={product}
            addToCart={addToCart}
          />
        ))}
      </div>
    </div>
  );
}

export default Products;
